import { TYPE_KEY } from "../common/constant";
import rest from "../common/rest";

export const REDUCER = "UNIVERSITY/";

export const UNIVERSITY_LIST_LOAD_REQUEST = REDUCER + "UNIVERSITY_LIST_LOAD_REQUEST";
export const UNIVERSITY_LIST_LOAD_SUCCESS = REDUCER + "UNIVERSITY_LIST_LOAD_SUCCESS";
export const UNIVERSITY_LIST_LOAD_FAIL = REDUCER + "UNIVERSITY_LIST_LOAD_FAIL";

// state props
export const UNIVERSITY_LIST = "universityList";

const initialState = {
  [UNIVERSITY_LIST]: []
};

export default function reducer(state = initialState, action) {
  let newState;
  switch (action[TYPE_KEY]) {
    case UNIVERSITY_LIST_LOAD_SUCCESS:
      newState = {
        ...state,
        [UNIVERSITY_LIST]: action[UNIVERSITY_LIST]
      };
      break;

    default:
      newState = { ...state };
      break;
  }

  return newState;
}

export function loadUniversities() {
  return (dispatch) => {
    rest.doGet(`/admin/admin/university`).then((result) => {
      dispatch({ [TYPE_KEY]: UNIVERSITY_LIST_LOAD_SUCCESS, [UNIVERSITY_LIST]: result });
    });
  };
}
